<template>
    <div class=".container-fluid full-height">
        <NavBar></NavBar>

            <div class="KSpinner" v-if="isInitiating">                    
                <div class="spinner-border text-info"></div>
                <h2 class="LoadingText">Loading....</h2>
            </div>

            <div class="ipannel m-5 mt-3" v-else>

                <div class="iscreentitleDiv mb-0">
                    <h2 v-if="activeMode == 'new'" class="iscreentitle">Create Vessel</h2>
                    <h2 v-if="activeMode == 'edit'" class="iscreentitle">Edit Vessel</h2>
                </div>

                <form @submit.prevent="submit"> 

                    <div class="row">                

                        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 " > 

                            
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group required text-left mb-1">
                                        <label for="vname" class="ilabel" >Vessel Name</label>
                                        <input type="text" class="form-control itextinput" id="vname" v-model="vessel.name" required maxlength = "150" :disabled="activeMode=='view'">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group required text-left mb-1">
                                        <label for="vtype" class="ilabel" >Type</label>
                                        <b-form-select class = "iselect" v-model="vessel.type" :options="vesselTypes" required :disabled="activeMode=='view'"></b-form-select>
                                    </div>                       
                                </div> 
                            </div> 
                            <div class="row">
                                <div class="col-6">   
                                    <div class="form-group required text-left mb-1">
                                        <label for="vflag" class="ilabel" >Flag</label>
                                        <b-form-select class = "iselect" v-model="vessel.flag" :options="countries" required :disabled="activeMode=='view'"></b-form-select>
                                    </div> 
                                </div>
                                <div class="col-6">
                                    <div class="form-group required text-left mb-1">
                                        <label for="vflag" class="ilabel" >Principal</label>
                                        <b-form-select class = "iselect" v-model="vessel.client" :options="clients" required :disabled="activeMode=='view'"></b-form-select>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group required text-left mb-1">
                                        <label for="vtype" class="ilabel" >IMO</label>
                                        <input type="text" class="form-control  itextinput" id="vtype" v-model="vessel.imo" maxlength = "100" required :disabled="activeMode=='view'">
                                    </div>                                    
                                </div>                             
                                <div class="col-6">   
                                    <div class="form-group required text-left mb-1">
                                        <label for="vtype" class="ilabel" >CBA</label>
                                        <b-form-select id = 'CBADropDown' class = "iselect" v-model="vessel.cba" :options="CBAs" required :disabled="activeMode=='view'"></b-form-select>
                                    </div>                                      
                                </div>
                            </div> 
                            <div class="row">
                                <div class="col-6">   
                                    <div class="form-group required text-left mb-1">
                                        <label for="vtype" class="ilabel" >GRT</label>
                                        <input type="text" class="form-control  itextinput" id="vtype" v-model="vessel.grt" maxlength = "100" required :disabled="activeMode=='view'">
                                    </div>                                      
                                </div>
                                <div class="col-6">
                                    <div class="form-group text-left mb-1">
                                        <label for="vtype" class="ilabel" >DWT</label>
                                        <input type="text" class="form-control  itextinput" id="vtype" v-model="vessel.dwt" maxlength = "100" :disabled="activeMode=='view'">
                                    </div>                                    
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group text-left mb-1">
                                        <label for="vtype" class="ilabel" >HP</label>
                                        <input type="text" class="form-control  itextinput" id="vtype" v-model="vessel.hp" maxlength = "100" :disabled="activeMode=='view'">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group text-left mb-1">
                                        <label for="vtype" class="ilabel" >KW</label>
                                        <input type="text" class="form-control  itextinput" id="vtype" v-model="vessel.kw" maxlength = "100" :disabled="activeMode=='view'">
                                    </div>  
                                </div>                                
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group text-left mb-1">
                                        <label for="vtype" class="ilabel" >Engine</label>
                                        <input type="text" class="form-control  itextinput" id="vtype" v-model="vessel.engine" maxlength = "100" :disabled="activeMode=='view'">
                                    </div>
                                </div>
                                <div class="col-6">                                    
                                    <div class="form-group text-left mb-1">
                                        <label for="vyearOfBuilt" class="ilabel" >Year of Built</label>
                                        <input type="text" class="form-control  itextinput" id="vyearOfBuilt" v-model="vessel.yearOfBuilt" maxlength = "4" minlength = "4" placeholder="YYYY" :disabled="activeMode=='view'">
                                    </div>                         
                                </div>
                            </div>
                        </div> <!-- column -->
                        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6" style="margin-top:30px;">
                            <div class=".container" style="max-height:220px;max-width:auto;min-height:220px;margin-top:0px">
                                <img v-if="profilePicThumbnailURL != ''" :src="profilePicThumbnailURL" class="image" style="max-height:200px;max-width:auto;min-height:200px">
                                <img v-else src="@/assets/vessel.jpg" class="image" style="max-height:200px;max-width:auto;min-height:200px">             
                            </div>

                            <div>
                                <div class="btn-group" role="group" aria-label="Basic example" v-if="activeMode!='view'">
                                    <button type="button" class="btn btn-success ibutton" :disabled="isLoading" @click="onProfilePicUploadButton">Upload</button>
                                    <button type="button" class="btn btn-success ibutton" :disabled="isLoading" v-if="profilePicThumbnailURL != ''"  @click="onDeleteProfilePic">Delete</button>
                                </div>
                                <input type="file" accept="image/*" @change="onProfilePicUpload" style="display: none"  ref="fileInputProfilePicVessel" />
                            </div>
                        </div> 
                </div> <!-- row --> 
                <div class=".container">
                    <div class="card mt-3">
                        <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Articles</div>
                        <div class="d-flex justify-content-left pl-1 " style="padding-top:10px;">
                            <button type="button" class="btn btn-primary ibutton m-2"  :disabled="isLoading" @click="addNewArticle"  v-if="activeMode!='view'">
                                <font-awesome-icon icon="plus" size="sm"/>
                                Add Article
                            </button>
                            <button type="button" class="btn btn-secondary ibutton m-2"  :disabled="isLoading" @click="showArchivedDocs = !showArchivedDocs" v-if="activeMode != 'new'">
                                <font-awesome-icon icon="eye" size="sm"/>
                                {{ showArchivedDocsBtnTxt }}
                            </button>
                        </div>

                        <div class="row pl-3">
                            <div class="col-3">
                                <div class="form-group required text-left pb-0 mb-0">
                                    <label class="ilabel" v-if="articles.length != 0">Article Number</label>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group required text-left pb-0 mb-0">
                                    <label class="ilabel" v-if="articles.length != 0">Start Date</label>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group required text-left pb-0 mb-0">
                                    <label class="ilabel" v-if="articles.length != 0">End Date</label>
                                </div>
                            </div>
                            <div class="col-2" >                                          
                                <div class="form-group text-left pt-0 pr-2 pb-0 mb-0">
                                    <label for="vfile" class="ilabel" v-if="articles.length != 0">Scanned Documents</label>
                                </div> 
                            </div>
                            <div class="col-1" >                                          
                                <div class="form-group text-left pt-0 pr-2 pb-0 mb-0">
                                </div> 
                            </div>
                        </div>  
                        <div v-for="article in articles" :key="article.id">
                            <div class="row pl-3">
                                <div class="col-3">
                                    <div class="form-group required text-left">
                                        <b-form-input type="text" class="form-control  itextinput" v-model="article.number" maxlength = "100" required :disabled="activeMode=='view'"></b-form-input>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group required text-left">
                                        <b-form-input :id="`vesselArticleDOI${article.id}`" :ref="`vesselArticleDOI${article.id}`" type="text" class="form-control  itextinput" v-model="article.dateOfIssue" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(article.dateOfIssue)" :disabled="activeMode=='view'"></b-form-input>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group required text-left">
                                        <b-form-input :id="`vesselArticleDOE${article.id}`" :ref="`vesselArticleDOE${article.id}`" type="text" class="form-control  itextinput" v-model="article.dateOfExpiry" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(article.dateOfExpiry)" :disabled="activeMode=='view'"></b-form-input>
                                    </div>
                                </div>
                                <div class="col-2" >                                          
                                    <div class="form-group text-left pt-0 pr-2">
                                        <button v-if="article.fileInfo != undefined && article.fileInfo.length != 0" class="btn btn-success btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('VesselArticles', '',article.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage Articles</button>
                                        <button v-else class="btn btn-info btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('VesselArticles', '',article.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage Articles</button>
                                    </div> 
                                </div>
                                <div class="col-1" >                                          
                                    <div class="form-group text-left pt-0 pr-2">
                                        <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteArticle(article.id)"  v-if="activeMode!='view'"><font-awesome-icon icon="window-close" size="lg"/></button>
                                    </div> 
                                </div>
                            </div>                        
                        </div>

                        <!-- Archived Articles -->
                        <div v-if="showArchivedDocs == true">
                            <div class="iscreentitleDiv">
                                <h2 class="iscreentitle">Archived Articles</h2>
                            </div> 
                            <div v-for="article in archivedArticles" :key="article.id">
                                <div class="row pl-3">
                                    <div class="col-3">
                                        <div class="form-group required text-left">
                                            <b-form-input type="text" class="form-control  itextinput" v-model="article.number" maxlength = "100" required></b-form-input>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group required text-left">
                                            <b-form-input :id="`vesselArticleDOI${article.id}`" type="text" class="form-control  itextinput" v-model="article.dateOfIssue" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(article.dateOfIssue)"></b-form-input>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group required text-left">
                                            <b-form-input :id="`vesselArticleDOE${article.id}`" type="text" class="form-control  itextinput" v-model="article.dateOfExpiry" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(article.dateOfExpiry)"></b-form-input>
                                        </div>
                                    </div>
                                    <div class="col-3" >                                          
                                        <div class="form-group text-left pt-0 pr-2">
                                            <button v-if="article.fileInfo != undefined && article.fileInfo.length != 0" class="btn btn-success btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('VesselArticles', '',article.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage Articles</button>
                                            <button v-else class="btn btn-info btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('VesselArticlesArchived', '',article.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage Articles</button>
                                        </div> 
                                    </div>
                                </div>                        
                            </div>
                        </div>
                        <!-- End of Archived Articles -->
                        
                    </div>   



                <!-- ###############  Vessel MLC Certificates ####################-->

                <div class="card mt-3">
                    <div class="card-header pt-3" style="font-weight:bold;font-size:14px">Vessel MLC Certificates</div>
                    <div class="d-flex justify-content-left pl-1 " style="padding-top:10px;">
                        <button type="button" class="btn btn-primary ibutton m-2"  :disabled="isLoading" @click="addNewMLC"  v-if="activeMode!='view'">
                            <font-awesome-icon icon="plus" size="sm"/>
                            Add MLC Certificate
                        </button>                            
                    </div>

                    <div class="row pl-3">
                        <div class="col-3">
                            <div class="form-group required text-left pb-0 mb-0">
                                <label class="ilabel" v-if="mlcCertificates.length != 0">MLC Cert Number</label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group required text-left pb-0 mb-0">
                                <label class="ilabel" v-if="mlcCertificates.length != 0">Start Date</label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group required text-left pb-0 mb-0">
                                <label class="ilabel" v-if="mlcCertificates.length != 0">End Date</label>
                            </div>
                        </div>
                        <div class="col-2" >                                          
                            <div class="form-group text-left pt-0 pr-2 pb-0 mb-0">
                                <label for="vfile" class="ilabel" v-if="mlcCertificates.length != 0">Scanned Documents</label>
                            </div> 
                        </div>
                        <div class="col-1" >                                          
                            <div class="form-group text-left pt-0 pr-2 pb-0 mb-0">
                            </div> 
                        </div>
                    </div>  
                    <div v-for="mlc in mlcCertificates" :key="mlc.id">
                        <div class="row pl-3">
                            <div class="col-3">
                                <div class="form-group required text-left">
                                    <b-form-input type="text" class="form-control  itextinput" v-model="mlc.number" maxlength = "100" required :disabled="activeMode=='view'"></b-form-input>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group required text-left">
                                    <b-form-input :id="`vesselMLCDOI${mlc.id}`" :ref="`vesselMLCDOI${mlc.id}`" type="text" class="form-control  itextinput" v-model="mlc.dateOfIssue" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(mlc.dateOfIssue)" :disabled="activeMode=='view'"></b-form-input>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group required text-left">
                                    <b-form-input :id="`vesselMLCDOE${mlc.id}`" :ref="`vesselMLCDOE${mlc.id}`" type="text" class="form-control  itextinput" v-model="mlc.dateOfExpiry" placeholder="DD/MM/YYYY" required  @blur="validateDateonBlur" :formatter="dateformatter" maxlength="10" :state="isValidDateForInput(mlc.dateOfExpiry)" :disabled="activeMode=='view'"></b-form-input>
                                </div>
                            </div>
                            <div class="col-2" >                                          
                                <div class="form-group text-left pt-0 pr-2">
                                    <button v-if="mlc.fileInfo != undefined && mlc.fileInfo.length != 0" class="btn btn-success btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('VesselMLCs', '',mlc.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage MLC Certificates</button>
                                    <button v-else class="btn btn-info btn-block ibutton" type="button" :disabled="isLoading" @click="showFileUploadsWindow('VesselMLCs', '',mlc.id)"><font-awesome-icon icon="file-pdf" size="sm"/>   Manage MLC Certificates</button>
                                </div> 
                            </div>
                            <div class="col-1" >                                          
                                <div class="form-group text-left pt-0 pr-2">
                                    <button class="btn ibutton" type="button" :disabled="isLoading" @click="deleteMLC(mlc.id)"  v-if="activeMode!='view'"><font-awesome-icon icon="window-close" size="lg"/></button>
                                </div> 
                            </div>
                        </div>                        
                    </div>
                    
                </div>  
                <!-- ###################################-->


                <div class="d-flex justify-content-center " style="padding-top:20px;margin-bottom:40px;"  v-if="activeMode!='view'">
                    <button type="submit" class="btn btn-primary ibutton mr-3"  :disabled="isLoading">
                        <span class="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true" v-if="this.isLoading"> </span>
                        <font-awesome-icon v-if="activeMode == 'new'" icon="plus" size="sm"/>
                        <font-awesome-icon v-if="activeMode == 'edit'" icon="edit" size="sm"/>
                        {{ getSubmitBtnTxt }} </button>
                </div>

                </div>  

                </form>
        
        
        </div>

        <v-dialog
            v-model="showFileUpload"
            persistent
            max-width="1600px"
            min-width="1000px"
            width="auto"
        >      
            <v-card>
                <v-toolbar
                dark
                color="primary"
                >                            
                <v-toolbar-title>Manage Files</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="showFileUpload = false"
                        >
                            <font-awesome-icon icon="window-close" size="lg"/>
                        
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
            
                <FileUploadWindow :fileInfo="fileUploadFileInfo" :parentInfo="fileUploadParentInfo" :mode="activeMode" :visible="showFileUpload"></FileUploadWindow>
                
            </v-card>
            
        </v-dialog>

        <v-snackbar v-model="showSnackbar" >
            {{ snackBarText }}
            <template v-slot:action="{ attrs }"> <v-btn :color="snackbarColor" text v-bind="attrs" @click="showSnackbar = false">Close</v-btn></template>
        </v-snackbar>

        <Footer class="footerStickedToBottom" ></Footer>        
   
    </div>    
</template>

<script>

import NavBar  from '@/components/NavBar';
import Footer from '@/components/Footer';
import FileUploadWindow from "@/components/FileUpload";
import Utils from '@/utils/util.js';
import FileUtils from '@/utils/fileUtils.js';
import { RefData } from '@/referenceData/refData';
import ImageUtils from '@/utils/imageUtils.js'
import moment from 'moment';
import {DB} from '../firebase/db';
import Firebase from 'firebase/app'
import dataStore from '../firebase/dataStore';

export default {   
    name: 'Vessel',  
    data() {
        return {

            activeMode: 'new',

            // Vessel Object
            vessel: {
                id                      :Utils.getUniqueID(),
                name                    :'',
                flag                    :'',
                client                  :'',
                cba                     :'',
                imo                     :'',
                grt                     :'',
                dwt                     :'',
                hp                      :'',
                kw                      :'',
                engine                  :'',
                type                    :'',
                yearOfBuilt             :'',

                createdBy               :'',
                createdAt               :'',
                modifiedBy              :'',
                modifiedAt              :'',

                profilePicURL           :'',
                profilePicThumbnailURL  :'',
            },
            

            // Profile Pic
            profilePicChanged       :false,
            profilePic              :null, //file
            profilePicThumbnail     :null, //file
            profilePicThumbnailURL  :null, //URL to preview in the form

            // Articles
            articles                :[],
            archivedArticles        :[],
            
            // Deleted Items
            deletedArticles : [],

            mlcCertificates : [],
            deletedMLCCertificates : [],

            // Ref Data
            countries               : RefData.countries,
            vesselTypes             : RefData.vesselTypes,
            clients                 : [], // This has mapping of ID to names    
            CBAs                    : [], // This has mapping of ID to names    

            // Window Status
            isInitiating    :false,
            isLoading       :false,
            showArchivedDocs:false,

            // SnackBar
            showSnackbar    :false,
            snackBarText    :'',
            snackbarColor   :'red',

            // File Upload
            showFileUpload          :false,     
            fileUploadFileInfo      : [],
            fileUploadParentInfo    :{type:'', subType:'', fileNamePrefix:0},
        }
    },
    components: {          
        NavBar,         
        Footer, 
        FileUploadWindow,       
    },
    created() {
        this.onCreated();       
    },
    watch:{
        fileUploadInfoGetter : function() {
             const uploadInfo = this.$store.state.fileUploadInfo;
             if(uploadInfo.status == 'New'){

                if(uploadInfo.parentInfo.type == 'VesselArticles'){
                    Utils.findFromArray(this.articles, uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                } 
                else if(uploadInfo.parentInfo.type == 'VesselMLCs'){
                    Utils.findFromArray(this.mlcCertificates, uploadInfo.parentInfo.parentID)?.fileInfo.push(Utils.createFileInfoObjFromUploadWindowObj(uploadInfo));
                } 
                // Common
                this.fileUploadFileInfo.push(uploadInfo);
            }
            else if(uploadInfo.status == 'Delete_New' || uploadInfo.status == 'Delete'){
                var list = undefined;
                if(uploadInfo.parentInfo.type == 'VesselArticles'){
                    list = Utils.findFromArray(this.articles, uploadInfo.parentInfo.parentID);
                }                
                else if(uploadInfo.parentInfo.type == 'VesselMLCs'){
                    list = Utils.findFromArray(this.mlcCertificates, uploadInfo.parentInfo.parentID);
                }  
                if(list != undefined){
                    Utils.spliceArray(list.fileInfo, uploadInfo.id)
                    Utils.spliceArray(this.fileUploadFileInfo, uploadInfo.id)
                }              
            }
        },
        thumbnailGetter : function() {
             this.profilePicThumbnail     = this.$store.state.profilePicThumbnailVessel;
        },
        thumbnailURLGetter : function() {
             this.profilePicThumbnailURL     = this.$store.state.profilePicThumbnailURLVessel;
        },
        clientGetter: function() {
            if(this.isInitiating) return;
            this.fetchCBAs();
        }

    },
    props:{
        mode:String,
        id:String,
    },
    computed:{
          
        fileUploadInfoGetter(){
            return this.$store.state.fileUploadInfo;
        },
        thumbnailURLGetter() {
            return this.$store.state.profilePicThumbnailURLVessel;
        },
        thumbnailGetter() {
            return this.$store.state.profilePicThumbnailVessel;
        },
        getSubmitBtnTxt(){
            if(this.activeMode == 'new')
                return 'Create Vessel'
            else
                return 'Save Changes'
        },
        showArchivedDocsBtnTxt(){
            if(this.showArchivedDocs == true)
                return 'Hide Archived Docs'
            else 
                return 'Show Archived Docs'
        }, 
        clientGetter(){
            return this.vessel.client;
        }
    },
    methods: {
        async onCreated(){      
            
            this.isInitiating = true;

            if(this.mode != undefined){
                this.activeMode = this.mode;                
            }else{
                this.activeMode = 'new';                
            } 

            await this.fetchRefData();  

            if(this.activeMode == 'new'){
                this.vessel.id = Utils.getUniqueID();                
            }else{
                this.vessel.id = this.id;
                await this.fetchVesselDetails(this.vessel.id);
            }

            this.deriveOriginalObject(); // For page leave warning

            this.isInitiating = false;
        },    
        async fetchRefData(){            
            const clientDetails = await DB.collection("clients").orderBy("modifiedAt", "desc").get();
            for(const doc of clientDetails.docs){
                this.clients.push({ value: doc.data().id, text: doc.data().name });
            }

            this.clients.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)            
        },    
        async fetchCBAs(){               
            this.CBAs = [];   
            const cbas = await dataStore.getAll("cba", [['client', "==", this.vessel.client]], [["modifiedAt", "desc"]]);             
            for(const cba of cbas){
                this.CBAs.push({ value: cba.id, text: cba.name });
            }

            this.CBAs.sort((a,b) => a.text.toLowerCase() < b.text.toLowerCase()? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0)
        },    
        async fetchVesselDetails(id){
            const vesselDetails = await DB.collection("vessels").where('id', '==', id).get();
            if(vesselDetails.empty){
                this.showError("Failed to fetch records");
                return;
            }else{
                this.vessel = vesselDetails.docs[0].data();
                this.profilePicThumbnailURL =  this.vessel.profilePicThumbnailURL;           
            }

            await this.fetchCBAs();

            const articleDetails = await DB.collection("articles").where('parentID', '==', id).where('status', '==', "Active").get();
            for(const doc of articleDetails.docs){
                
                var article = doc.data();
                
                this.articles.push(article);
            }      
            
            this.articles.sort((item1, item2) => {
                item1.modifiedAt < item2.modifiedAt? -1: item1.modifiedAt > item2.modifiedAt ? 1 : 0;
            })

            const mlcDetails = await DB.collection("mlcCertificates").where('parentID', '==', id).where('status', '==', "Active").get();
            for(const doc of mlcDetails.docs){
                
                var mlc = doc.data();
                
                this.mlcCertificates.push(mlc);
            }      
            
            this.mlcCertificates.sort((item1, item2) => {
                item1.modifiedAt < item2.modifiedAt? -1: item1.modifiedAt > item2.modifiedAt ? 1 : 0;
            })

        },
        deriveOriginalObject(){
            const tempVessel = Object.assign({}, this.vessel);
            tempVessel.id = '';
            this.originalObject = {
                vessel      :tempVessel,
                articles    :JSON.stringify(this.articles),
            };
        },
        async submit(){

            if(this.validateBeforeSubmit() == false)
                return;

            if(this.activeMode == 'new'){
                await this.createOrUpdateVessel(true);
                this.resetForm();
            }               
            else if(this.activeMode == 'edit'){
                await this.createOrUpdateVessel(false);  
                this.originalObject = this.getFormObject();
            } 
        },
        validateBeforeSubmit(){
            var isDateError = false;
            this.articles.forEach(item => {
                if(Utils.isValidDate(item.dateOfIssue) == false || Utils.isValidDate(item.dateOfExpiry) == false){
                    isDateError = true;
                    return;
                }
            })
            if(isDateError){
                this.showError("One or More Date fields having an Invalid Date");
                return false;
            }

            return true;
        }, 
        async createOrUpdateVessel(isCreation){











            this.isLoading = true;
            var errorMsg = "Failed to create Vessel";
            var successMsg = "Vessel created successfully";

            if(isCreation == true){
                const vesselDetails = await DB.collection("vessels").where('name', '==', this.vessel.name).get();
                if(!vesselDetails.empty){
                    this.showError("Vessel name already taken");
                    this.isLoading = false;
                    return;
                }
            }else{
                errorMsg = "Failed to update Vessel";
                successMsg = "Vessel updated successfully";
            }          

            //Upload profile PIC
            if(this.profilePicChanged){
                const urls = await this.uploadProfilePic();
                if(urls != null){
                    this.vessel.profilePicURL            = urls.profilePicURL;
                    this.vessel.profilePicThumbnailURL   = urls.profilePicThumbnailURL; 
                }                
            }                          

            //Upload files
            const fileUploadStatus = await this.uploadFiles();                     
            if(fileUploadStatus == false){
                this.showError(errorMsg);
                this.isLoading = false;
                return;
            }
          
            // Enrichments
            this.stampUpdateHash();
            if(isCreation){
                this.vessel.createdBy = Utils.getUser();
                this.vessel.createdAt = Firebase.firestore.FieldValue.serverTimestamp();
            }            
            this.vessel.modifiedBy = Utils.getUser();
            this.vessel.modifiedAt = Firebase.firestore.FieldValue.serverTimestamp();

            var batch = DB.batch();

            var vesselRef = DB.collection("vessels").doc(this.vessel.id);
            if(isCreation)
                batch.set(vesselRef, this.vessel);
            else
                batch.update(vesselRef, this.vessel);


            this.articles.forEach(async article => {                

                var articleRef = DB.collection("articles").doc(article.id);
                // Prepare object to be uploaded
                const uploadArticle = Object.assign({}, article);
                if(uploadArticle.status == 'New'){
                    uploadArticle.status = 'Active';
                    batch.set(articleRef, uploadArticle);
                }else{
                    batch.update(articleRef, uploadArticle);
                }
            });


            
            this.deletedArticles.forEach(article => {
                var articleRef = DB.collection("articles").doc(article.id);
                batch.delete(articleRef);
            })
            this.deletedArticles = [];


            this.mlcCertificates.forEach(async mlc => {               

                var mlcRef = DB.collection("mlcCertificates").doc(mlc.id);
                // Prepare object to be uploaded
                const uploadMLC = Object.assign({}, mlc);
                if(uploadMLC.status == 'New'){
                    uploadMLC.status = 'Active';
                    batch.set(mlcRef, uploadMLC);
                }else{
                    batch.update(mlcRef, uploadMLC);
                }
            });



            this.deletedMLCCertificates.forEach(mlc => {
                var mlcRef = DB.collection("mlcCertificates").doc(mlc.id);
                batch.delete(mlcRef);
            })
            this.deletedMLCCertificates = [];


            const _this = this;
            batch.commit().then(() => {
                _this.showMsg(successMsg);
                _this.isLoading = false;
            }).catch((err) => { 
                console.log(err)
                _this.showError(errorMsg);
                _this.isLoading = false;
            });
        },        
        stampUpdateHash(){
            const updateHash = Utils.getUniqueID();

            this.vessel.updateHash = updateHash;

            this.articles.forEach(item => {
                item.updateHash = updateHash;

                item.fileInfo.forEach(fileInfo => {
                    fileInfo.updateHash = updateHash;
                });
            })
        },
        async uploadProfilePic(){
            if(this.profilePic != null && this.profilePicThumbnail != null){
                const url = await FileUtils.uploadFile(this.profilePic, 'images/vesselPics/', this.vessel.id)
                const thumbnailUrl = await FileUtils.uploadFile(this.profilePicThumbnail, 'images/vesselPics/thumbnails/', this.vessel.id);
                return { profilePicURL: url, profilePicThumbnailURL: thumbnailUrl};
            }else{
                return null;
            }
        },
        async uploadFiles(){           

            for(let i = 0 ; i < this.articles.length; i++){
                await FileUtils.uploadFileList(this.articles[i].fileInfo, 'VesselArticles');                
            }            
            for(let i = 0 ; i < this.mlcCertificates.length; i++){
                await FileUtils.uploadFileList(this.mlcCertificates[i].fileInfo, 'MLCCertificates');                
            }            
            return true;
        },
        showFileUploadsWindow (type, subType, articleID){ // index starts from 0

            if(this.isFileUploadAllowedForRole(type) == false){
                return;
            }

            this.showFileUpload                 = true;

            // reset
            this.fileUploadFileInfo = [];
            
            // - Parent info
            this.fileUploadParentInfo.type      = type;
            this.fileUploadParentInfo.subType   = subType;
            this.fileUploadParentInfo.parentID  = articleID;
            this.fileUploadParentInfo.fileNamePrefix     = Utils.getUniqueID();

            // - Type Specific info
            if(type == 'VesselArticles'){  
                Utils.findFromArray(this.articles, articleID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
            if(type == 'VesselArticlesArchived'){  
                Utils.findFromArray(this.articlesArchived, articleID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
            if(type == 'VesselMLCs'){  
                Utils.findFromArray(this.mlcCertificates, articleID)?.fileInfo.forEach(item=>{this.fileUploadFileInfo.push(Utils.convertFileInfoObjToUploadWindowObj(item))});
            }
        },
        isFileUploadAllowedForRole(type){
            if(this.$store.state.user != undefined && this.$store.state.user != null){
                if(this.$store.state.user.role != undefined && (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Operator')){
                    return true;
                }else if(this.$store.state.user.role != undefined && this.$store.state.user.role == 'Accountant'){
                    if(type == 'preJoiningReimbursments' || type == 'bankDocuments' || type == 'bankDocumentsForeign'){
                        return true;
                    }
                }
            }
            return false;
        },
        getFileInfo(fileInfoList, id){
            return fileInfoList.find(item => { return item.id === id  });
        },        
        dateformatter(value){
            return Utils.dateformatter(value);
        },
        isValidDateForInput(dateIn){
            return Utils.isValidDateForInput(dateIn);
        },
        validateDateonBlur(e){
            const value = this.$refs[e.target.id][0].value;

            if(e.target.id.length > 16 && e.target.id.substring(0,16) == 'vesselArticleDOI'){
                // this.$refs[]
                if(Utils.isValidDate(value) == false){
                    this.showError('Start Date is invalid. Format should be DD/MM/YYYY');
                }
                this.articles.forEach(item => {
                    if(item.id == e.target.id.substring(16)){
                        item.dateOfExpiry = this.getDateOfExpiry(value);
                    }
                })
            }
            else if(e.target.id.length > 16 && e.target.id.substring(0,16) == 'vesselArticleDOE'){
                if(Utils.isValidDate(value) == false){
                    this.showError('End Date is invalid. Format should be DD/MM/YYYY');
                }
            }else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'vesselMLCDOI'){
                if(Utils.isValidDate(value) == false){
                    this.showError('Start Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            else if(e.target.id.length > 12 && e.target.id.substring(0,12) == 'vesselMLCDOE'){
                if(Utils.isValidDate(value) == false){
                    this.showError('End Date is invalid. Format should be DD/MM/YYYY');
                }
            }
            
        },  
        onProfilePicUploadButton(){
            this.$refs.fileInputProfilePicVessel.click();
        },
        async onProfilePicUpload(e) {
            if(e.target.files.length == 0)
                return;

            this.profilePicChanged = true;

            const file          = e.target.files[0];
            this.profilePic     = file;
            ImageUtils.compressImage(file, 200, 'vessel');

        },
        onDeleteProfilePic(){
            this.profilePic             = null;
            this.profilePicThumbnail    = null;
            this.profilePicURL          = '';
            this.profilePicThumbnailURL = '';
            this.$refs.fileInputProfilePicVessel.value = null;
            this.$store.commit('deleteProfilePicThumbnailVessel');

            this.vessel.profilePicThumbnailURL = '';

        }, 
        addNewArticle(){
            this.articles.push({
                id              :Utils.getUniqueID(), 
                parentID        :this.vessel.id, 
                createdAt       :Utils.getUTCDateTime(), modifiedAt:Utils.getUTCDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash      :'',
                number          : '',
                dateOfIssue     : '',
                dateOfExpiry    : '',
                fileInfo        :[],
                status          : 'New'
            })
        },                
        deleteArticle(id){
            if(confirm("Are you sure you want to delete the record?")){
                
                var result = this.articles.find(obj => {
                    return obj.id === id
                })

                if(result != undefined){
                    Utils.spliceArray(this.articles, id);
                    
                    if(this.articles.status != 'New'){  
                        this.deletedArticles.push(result);
                    }
                }
            }
        },
        addNewMLC(){
            this.mlcCertificates.push({
                id              :Utils.getUniqueID(), 
                parentID        :this.vessel.id, 
                createdAt       :Utils.getUTCDateTime(), modifiedAt:Utils.getUTCDateTime(), createdBy:Utils.getUser(), modifiedBy:Utils.getUser(), 
                updateHash      :'',
                number          : '',
                dateOfIssue     : '',
                dateOfExpiry    : '',
                fileInfo        :[],
                status          : 'New'
            })
        },                
        deleteMLC(id){
            if(confirm("Are you sure you want to delete the record?")){
                
                var result = this.mlcCertificates.find(obj => {
                    return obj.id === id
                })

                if(result != undefined){
                    Utils.spliceArray(this.mlcCertificates, id);
                    
                    if(this.mlcCertificates.status != 'New'){  
                        this.deletedMLCCertificates.push(result);
                    }
                }
            }
        },
        
              
        getDateOfExpiry(dateIn){
            if(dateIn != '' && Utils.isValidDate(dateIn)){
                var date = moment(dateIn, "DD/MM/YYYY").add(1, 'years');
                date = date.add(-1, 'days');
                var day = date.format('DD');
                var month = date.format('MM');
                var year = date.format('YYYY');
                return day + '/' + month + '/' + year;
            }
            return '';
        },         
        showError(err){
            this.snackBarText = err;
            this.snackbarColor = 'red';
            this.showSnackbar = true;
        },          
        showMsg(msg){
            this.snackBarText = msg;
            this.snackbarColor = 'green';
            this.showSnackbar = true;
        },
        resetForm(){
            this.vessel = {
                id                      : Utils.getUniqueID(),
                name                    :'',
                flag                    :'',
                client                  :'',
                cba                     :'',
                imo                     :'',
                grt                     :'',
                dwt                     :'',
                hp                      :'',
                kw                      :'',
                engine                  :'',
                type                    :'',
                yearOfBuilt             :'',

                createdBy               :'',
                createdAt               :'',
                modifiedBy              :'',
                modifiedAt              :'',

                profilePicURL           :'',
                profilePicThumbnailURL  :'',
            };
            

            // Profile Pic
            this.profilePicChanged       = false;
            this.profilePic              = null; //file
            this.profilePicThumbnail     = null; //file

            // Articles
            this.articles                = [];
            this.archivedArticles        = [];
            this.mlcCertificates        = [];
            
            // Deleted Items
            this.deletedArticles         = [];
            this.deletedMLCCertificates         = [];

            // File Upload
            this.fileUploadFileInfo      = [];
        },
        getFormObject(){
            const tempVessel = Object.assign({}, this.vessel);
            tempVessel.id = '';
            const formObject = {
                vessel      :tempVessel,
                articles    :JSON.stringify(this.articles),
            };

            return formObject;
        },
        isThereUnsavedChanges(){
            const currentObject = this.getFormObject();
            if(JSON.stringify(this.originalObject) === JSON.stringify(currentObject)){
                return false;
            }else{
                return true;
            }
        },       
    },
    beforeRouteLeave: function(to, from, next) {
        if(this.isThereUnsavedChanges() == true){
            const answer = window.confirm('You have unsaved changes; are you sure you want to leave this page?')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next();
        }     
    }
}


</script>



<style lang="scss">
</style>
